import React from "react";
import { Link } from "react-router-dom";
import { scrollToPageTop } from "../../utils/scrollToPageTop";
import { VIRTUAL_CURRENCY_DISCLAIMER } from "../../utils/virtualCurrencyDisclaimer";

interface ShopFooterProps {
  className?: string;
}

export default function ShopFooter({ className = "" }: ShopFooterProps) {
  const scrollToTop = () => scrollToPageTop({ defer: true });

  return (
    <div className={"w-full flex flex-col gap-2 " + className}>
      <p className="px-1 text-center font-chakra text-[11px] leading-relaxed text-white/60 normal-case sm:text-[12px]">
        {VIRTUAL_CURRENCY_DISCLAIMER}
      </p>
      <div className="flex h-10 w-full flex-row items-center justify-center gap-2 border-t border-[#1B062F] bg-[#401A6E] text-[14px] text-white">
        <Link
          to="/account?t=tran"
          onClick={scrollToTop}
          className="cursor-pointer font-chakra transition-colors hover:text-lime"
        >
          Transactions
        </Link>
        <span>•</span>
        <Link
          to="/contact"
          onClick={scrollToTop}
          className="cursor-pointer font-chakra transition-colors hover:text-lime"
        >
          Contact
        </Link>
        <span>•</span>
        <Link
          to="/terms"
          onClick={scrollToTop}
          className="cursor-pointer font-chakra transition-colors hover:text-lime"
        >
          Terms
        </Link>
        <span>•</span>
        <Link
          to="/refundpolicy"
          onClick={scrollToTop}
          className="cursor-pointer font-chakra transition-colors hover:text-lime"
        >
          Refund policy
        </Link>
      </div>
    </div>
  );
}
